import { VerificationTemplate } from "../../templates/VerificationTemplate/VerificationTemplate";

const VerificationPage = () => {
  return <VerificationTemplate />;
};

export default VerificationPage;
